import { Helmet } from "react-helmet-async";
import { SITE_URL } from "../lib/schema";

const DEFAULT_OG_IMAGE =
  "https://images.unsplash.com/photo-1716396635935-b7ba3d91a1cb?auto=format&fit=crop&w=1200&q=70";

export default function SEO({ title, description, path = "/", jsonLd = [], ogImage, noindex = false }) {
  const canonical = `${SITE_URL}${path === "/" ? "/" : `${path}/`}`;
  const fullTitle = path === "/" ? title : `${title} — Adika Tech`;
  const image = ogImage || DEFAULT_OG_IMAGE;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Adika Tech" />
      <meta property="og:locale" content="en_IN" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content="Adika Tech — software products and engineering services, Mumbai" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {jsonLd.map((schema, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}
